import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import equalHeight from '../functions/equalHeight';
import BackToTop from '../components/chunks/BackToTop';
import {getSurface} from '../actions/surfaceActions';
import {getCategory} from '../actions/categoryActions';
import {filterMatches} from '../actions/productActions';
import PropTypes from 'prop-types';
import {APP_TITLE, MEDIA_URL} from '../constants/config';
import { Helmet } from 'react-helmet';

class Options extends React.Component{
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        if(this.props.options && this.props.options.length == 1) {
            const item = this.props.options[0];
            const url = `/${this.props.surface.slug}/${this.props.category.slug}/${item.slug}/products`;
            browserHistory.replace(url);
        }
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        equalHeight(document.querySelectorAll('.block_item header'));
    }

    loop() {
        if(this.props.options) {
            return this.props.options.map((b, i) =>
                <div key={i} className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <Link to={"/" + this.props.surface.slug + "/" + this.props.category.slug + "/" + b.slug + "/products"} className="block_item">
                        <header className="py-3 px-4"><h4 className="mb-1">{(b.description == '') ? b.name : b.description}</h4></header>
                        <div>
                            <img src={MEDIA_URL + "option/" + this.props.category.slug + "/" + this.props.surface.slug + "/" + b.slug + ".jpg"} className="img-fluid" alt={this.props.surface.name + " - " + ((b.description == '') ? b.name : b.description)}/>
                        </div>
                    </Link>
                </div>
            );
        }
    }

    render() {
        return (
            <div id="options">
                <Helmet>
                    <title>The Symptoms | {APP_TITLE}</title>
                </Helmet>
                <h2 className="entry-title"><small>Choosing {this.props.category.name} for your {this.props.surface.name} surface</small><br />{this.props.category.label}</h2>

                <div className="row entry">
                    {this.loop()}
                </div>
                <BackToTop />
            </div>
        );
    }

}

// Maps state from store to props
const mapStateToProps = (state, props) => {

    let category = getCategory(props.params.category, state);
    let surface = getSurface(props.params.floorSurface, state);
    let options = state.options[category.slug];
    let matches = [];

    if(options && options.length > 0) {
        for (const option of options) {
            let products = filterMatches({
                ...props.params,
                option: option.slug
            }, state);
            if(products) {
                matches.push(option);
            }
        }
    }

    return {
        // You can now say this.props.books
        surface: surface,
        category: category,
        options: matches,
    };

};

Options.propTypes = {
    surface: PropTypes.object,
    category: PropTypes.object,
    options: PropTypes.array,
};

// Use connect to put them together
export default connect(mapStateToProps)(Options);


// WEBPACK FOOTER //
// ./src/components/Options.js